<div class="row">
  <div class="col-12">
    <div class="table__main">
      <table class="table" aria-describedby="mydesc">
        <thead>
          <tr>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Fecha seguimiento</div>
              </div>
            </th>
            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Usuario</div>
              </div>
            </th>

            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Estado</div>
              </div>
            </th>

            <th>
              <div class='filter-container header-container'>
                <div class='header-text'>Observaciones</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of statusName let i = index">
            <td>{{item.registrationDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
            <td>{{item.fullName}}</td>
            <td>{{item.status}}</td>
            <td>{{item.observation}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
